import { Box } from '@mui/material';
import { LeveragedPositionsList } from './lists/LeveragedPositionsList/LeveragedPositionsList';
import { ToLeveragePositionsList } from './lists/ToLeveragePositionsList/ToLeveragePositionsList';

export const LeverageContentWrapper = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 4, md: 8 },
        width: '100%',
      }}
    >
      <LeveragedPositionsList />
      <ToLeveragePositionsList />
    </Box>
  )
};
